module.exports = __webpack_public_path__ + "img/UTJORD-5.a2353421.jpg";